import { messagesApi } from '../../api';
import { expertsApi } from '../../api';

export const SET_EXPERTS = 'EXPERTS:SET_EXPERTS';
export const SET_EXPERT_TYPING = 'EXPERTS:SET_TYPING';
export const RESET_EXPERT_TYPING = 'EXPERTS:RESET_EXPERT_TYPING';
export const RESET_EXPERT = 'EXPERTS:RESET_EXPERT';
export const SET_EXPERT_STATUS = 'EXPERTS:SET_EXPERT_STATUS';
export const SET_CHANGE_EXPERT_REASONS = 'EXPERTS:SET_CHANGE_EXPERT_REASONS';
export const SET_IS_CALL_NEW_EXPERT_BUTTON_DISABLED = 'EXPERTS:SET_IS_CALL_NEW_EXPERT_BUTTON_DISABLED';

const actions = {
  subscribeExpertTyping: {
    handle: SET_EXPERT_TYPING,
    event: 'expert.typing',
  },
  setCallNewExpertButtonDisabled: (status) => ({
      type: SET_IS_CALL_NEW_EXPERT_BUTTON_DISABLED,
      payload: status
  }),
  subscribeExpertStatus: {
    event: 'expert.statusChanged',
    handle: SET_EXPERT_STATUS,
  },
  setChangeExpertReasons: {
    handle: SET_CHANGE_EXPERT_REASONS,
    event: 'expertChangeReasons',
  },
  setActiveExpertId: (expertId) => ({
    type: SET_EXPERTS,
    payload: expertId
}),
  setNewExpert: {
    handle: SET_EXPERTS,
    event: 'expert.changed'
  },
  listenExpertJoin: () => (dispatch) => {
    dispatch(actions.setNewExpert);
  },
  expertTypingSubscription: () => (dispatch) => {
    dispatch(actions.subscribeExpertTyping);
  },
  changeExpert: (dialogId, buyerId, reasonId, customReason) => {
    messagesApi.changeExpert(dialogId, buyerId, reasonId, customReason);
    return {
      type: RESET_EXPERT,
    };
  },
  expertStatusChangedSubscription: () => (dispatch) => {
    dispatch(actions.subscribeExpertStatus);
  },
  getChangeExpertReasons: () => (dispatch) => {
    dispatch(actions.setChangeExpertReasons);
    expertsApi.getChangeExpertReasons();
  },
};

export default actions;
